import React from 'react';
import { MessageCircle } from 'lucide-react';

const WhatsAppButton = () => (
  <a
    href="https://wa.me/554131800650"
    target="_blank"
    rel="noreferrer"
    aria-label="WhatsApp"
    className="fixed bottom-6 right-6 z-40 w-14 h-14 rounded-full bg-[#25D366] flex items-center justify-center shadow-[0_10px_30px_-6px_rgba(37,211,102,0.6)] hover:scale-105 transition-transform"
  >
    <MessageCircle className="w-7 h-7 text-white" strokeWidth={2.2} />
  </a>
);

export default WhatsAppButton;
